module.exports = __webpack_public_path__ + "img/skin-dryness.d83cc679.svg";